import { Typography, Paper, IconButton, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import React from "react";
import { Container } from "reactstrap";
import { FormatDataByTypeCode } from "../form-client";
import { isNullOrUndefined } from "./WidgetUtil";

export const RefreshContext = React.createContext<React.Dispatch<React.SetStateAction<(() => void) | null>> | null>(null);

interface WidgetLayoutProps {
	navText?: string;
	onLogout?: () => void;
	children: React.ReactNode;
}

export function WidgetLayout(props: WidgetLayoutProps) {
	const [refreshHandler, setRefreshHandler] = React.useState<(() => void) | null>(null);

	return (
		<div style={{ height: "100%" }}>
			<header>
				<div style={{ width: "100%", padding: "5px 8px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #ebebeb" }}>
					<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
						Client Portal
					</Typography>
					{props.onLogout && (
						<Button size="small" variant="outlined" onClick={props.onLogout}>
							Log out
						</Button>
					)}
				</div>
			</header>
			<Container style={{ height: "calc(100% - 42px)" }}>
				<Paper sx={{ padding: 2, height: "100%", overflowY: "auto" }}>
					{!isNullOrUndefined(props.navText) && (
						<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
							<Typography variant="h6">{props.navText + " - " + FormatDataByTypeCode(new Date(), "D")}</Typography>
							{refreshHandler && (
								<IconButton onClick={refreshHandler} size="small" title="Refresh">
									<RefreshIcon />
								</IconButton>
							)}
						</div>
					)}
					<RefreshContext.Provider value={setRefreshHandler}>
						{props.children}
					</RefreshContext.Provider>
				</Paper>
			</Container>
		</div>
	);
}
